import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconDocumentation = createIcon({
  displayName: 'IconDocumentation',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M8 2H16V4H8V2ZM8 6H16V8H8V6ZM14 14H10V16H14V14ZM20 12H19H18H6V20H18V14H20V22H4V4H6V10H18V4H20V12Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
